import { useEffect } from "react";
import ContextMenu from "../common/ContextMenu";
import { useMenu } from "../layout/MenuContext";

const Background = ({ children }) => {
  const { menuItems, menuPosition, isMenuVisible, hideMenu } = useMenu();

  useEffect(() => {
    document.documentElement.style.height = "100%";
    document.body.style.height = "100%";

    return () => {
      document.documentElement.style.height = "";
      document.body.style.height = "";
    };
  }, []);

  const handleContextMenu = (e) => {
    if (e.target.classList.contains("hide-context-menu")) {
      e.preventDefault();
      return;
    }
  };

  return (
    <div
      className="background-container items-center justify-center bg-cover bg-gradient-to-br from-gray-900 via-gray-800 to-blue-900 overflow-auto"
      onContextMenu={handleContextMenu}
      style={{
        minHeight: "100vh",
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        width: "100%",
        height: "auto",
      }}
    >
      {children}
      {isMenuVisible && (
        <ContextMenu
          items={menuItems}
          x={menuPosition.x}
          y={menuPosition.y}
          onClose={hideMenu}
        />
      )}
    </div>
  );
};

export default Background;
